export default __webpack_public_path__ + "static/media/alan_logo.3c674864.png";